import Component from './Component'
import {
  BracketsRegex,
  RemoveBrackets,
  ValidateCondition,
  DynamicComponentToObject,
  isList as isListUtil,
  isDynamicComponent,
} from './utils'
import { path } from 'ramda'

const getValidation = (cur, suffix = '') =>
  path(['options', 'validation', ...suffix.split('.')].filter(Boolean), cur)
const BuildKey = (...parts) =>
  parts.filter(p => !['', undefined, null, false].includes(p)).join('.')
const Iterate = (arr, cb) =>
  Array(arr.length)
    .fill(undefined)
    .forEach((e, i) => cb(i))

function getValidatorConfigLabels(schema, data = {}, options = {}) {
  const { prefix = '' } = options



  if (!(schema instanceof Array)) schema = [schema]

  return schema.reduce((res, cur) => {
    if (!cur.label) return res

    let isList = isListUtil(cur)


    let targetData = path([...prefix.split('.'), ...cur.key.split('.')].filter(Boolean), data) || []

    if (!isDynamicComponent(cur.component)) {
      if (isList) Iterate(targetData, i => (res[BuildKey(prefix, cur.key, i)] = cur.label))
      else res[BuildKey(prefix, cur.key)] = cur.label
    } else {
      ; (typeof cur.component === 'string'
        ? DynamicComponentToObject(cur.component).components
        : cur.component
      ).forEach(e => {
        const { component, label, key } = e
        if (!label) return ''


        const isSublist = isListUtil(e)
        const isDynamic = isDynamicComponent(component)

        if (isDynamic) {
          if (isList) {
            return Iterate(targetData, i =>
              Object.assign(
                res,
                getValidatorConfigLabels(e, data, { prefix: BuildKey(prefix, cur.key, i) }),
              ),
            )
          } else {
            return Object.assign(
              res,
              getValidatorConfigLabels(e, data, { prefix: BuildKey(prefix, cur.key) }),
            )
          }
        }

        if (isList)
          Iterate(targetData, i => {
            if (!isSublist) return (res[BuildKey(prefix, cur.key, i, key)] = label)

            let subtargetData = path(key.split('.'), targetData[i]) || []

            Iterate(subtargetData, ii => (res[BuildKey(prefix, cur.key, i, key, ii)] = label))
          })
        else {
          if (!isSublist) return (res[BuildKey(prefix, cur.key, key)] = label)

          let subtargetData = path(key.split('.'), targetData) || []
          Iterate(subtargetData, ii => (res[BuildKey(cur.key, key, ii)] = label))
        }
      })
    }

    return res
  }, {})
}

function getValidatorConfigRules(schema, data = {}, options = {}) {

  const { prefix } = options

  if (!(schema instanceof Array)) schema = [schema]

  return schema.reduce((res, cur) => {
    const isList = isListUtil(cur)
    const validation = getValidation(cur)

    if (
      typeof validation === 'string' &&
      ValidateCondition(path(['options', 'condition'], cur), cur, data)
    ) {
      res[BuildKey(prefix, cur.key, isList ? '*' : null)] = validation
    }

    if (validation && typeof validation === 'object') {
      Object.entries(validation).forEach(([key, value]) => {
        if (
          !ValidateCondition(
            path(['options', 'condition', '*'], cur) || path(['options', 'condition', key], cur),
            undefined,
            data,
          )
        )
          return
        let target = cur.component.split(',').find(c => {
          let [, k] = RemoveBrackets(c).split(':')
          return k === key
        })
        res[
          [
            prefix,
            cur.key,
            isList ? '*' : false,
            key,
            target && Boolean(target.match(BracketsRegex)) ? '*' : false,
          ]
            .filter(Boolean)
            .join('.')
        ] = value
      })
    }

    const isDynamic = isDynamicComponent(cur.component) && cur.component instanceof Array

    if (isDynamic && ValidateCondition(path(['options', 'condition'], cur), cur, data)) {
      Object.assign(
        res,
        getValidatorConfigRules(cur.component, data, {
          prefix: BuildKey(prefix, cur.key, isList ? '*' : false),
        }),
      )
    }

    return res
  }, {})
}

function getValidatorConfig(schema, data = {}, options = {}) {

  const rules = getValidatorConfigRules(schema, data, options)
  if (!Object.keys(rules).length) return {}

  return {
    labels: getValidatorConfigLabels(schema, data, options),
    rules,
  }
}

export { getValidatorConfig }
export default Component
